// Auto-generated by tools/avatar/generate-clothing-svgs.mjs
 
import type { RecordOfClothingGraphicComponents } from './types'

import BatSvg from './bat.svg?raw'
import BasketballSvg from './basketball.svg?raw'
import BaseballSvg from './baseball.svg?raw'
import ClubSvg from './club.svg?raw'
import CumbiaSvg from './cumbia.svg?raw'
import DeerSvg from './deer.svg?raw'
import DiamondSvg from './diamond.svg?raw'
import FootballSvg from './football.svg?raw'
import HeartSvg from './heart.svg?raw'
import HolaSvg from './hola.svg?raw'
import HockeySvg from './hockey.svg?raw'
import PizzaSvg from './pizza.svg?raw'
import ResistSvg from './resist.svg?raw'
import SoccerBallSvg from './soccer-ball.svg?raw'
import SelenaSvg from './selena.svg?raw'
import SpadeSvg from './spade.svg?raw'
import BearSvg from './bear.svg?raw'
import SkullOutlineSvg from './skull-outline.svg?raw'
import SkullSvg from './skull.svg?raw'
import TennisBallSvg from './tennis-ball.svg?raw'
import TrophySvg from './trophy.svg?raw'
import VolleyballSvg from './volleyball.svg?raw'

export const clothingGraphicComponents = {
  Bat: BatSvg,
  Basketball: BasketballSvg,
  Baseball: BaseballSvg,
  Club: ClubSvg,
  Cumbia: CumbiaSvg,
  Deer: DeerSvg,
  Diamond: DiamondSvg,
  Football: FootballSvg,
  Heart: HeartSvg,
  Hola: HolaSvg,
  Hockey: HockeySvg,
  Pizza: PizzaSvg,
  Resist: ResistSvg,
  SoccerBall: SoccerBallSvg,
  Selena: SelenaSvg,
  Spade: SpadeSvg,
  Bear: BearSvg,
  SkullOutline: SkullOutlineSvg,
  Skull: SkullSvg,
  TennisBall: TennisBallSvg,
  Trophy: TrophySvg,
  Volleyball: VolleyballSvg,
} satisfies RecordOfClothingGraphicComponents

export type ClothingGraphicComponentName = keyof typeof clothingGraphicComponents
